import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "uv-details-header" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "uv-details-top" }
const _hoisted_4 = { class: "ac-row" }
const _hoisted_5 = { class: "ac-col uv-details-slider" }
const _hoisted_6 = { class: "ac-col uv-details-actions" }
const _hoisted_7 = { class: "uv-details-call-us" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 0,
  class: "uv-details-actions-price"
}
const _hoisted_11 = { class: "uv-details-actions-price-driveaway" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("sup", null, "$", -1)
const _hoisted_13 = {
  key: 0,
  class: "uv-details-actions-price-finance"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "FINANCE", -1)
const _hoisted_15 = { class: "weekly" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("sup", null, "$", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "wk" }, "/wk", -1)
const _hoisted_18 = { class: "uv-details-specs" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("dt", null, "Location", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("dt", null, "Model Year", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("dt", null, "Type", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("dt", null, "Kilometres", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("dt", null, "Colour", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("dt", null, "Transmission", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("dt", null, "Engine", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("dt", null, "Body", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("dt", null, "VIN", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("dt", null, "REG", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("dt", null, "Stock #", -1)
const _hoisted_30 = { class: "uv-details-specs-more" }
const _hoisted_31 = ["href"]

import { computed } from 'vue'; 
	
	import { EStockCategoryId } from '@/enums';
	import { commify } from '@/helpers';
	import { IVehicle } from '@/types.d'
	import VehicleFlagCertified from './VehicleFlagCertified.vue';
	import VehicleFlexSlider from './VehicleFlexSlider.vue';

	
export default /*#__PURE__*/_defineComponent({
  props: {
    vehicle: null,
    showLocation: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
		vehicle: IVehicle | null, 
		showLocation: boolean
	}

	

	const vehicleHrefPhoneNumber = computed(() => 'tel:' + props.vehicle?.PhoneNumber.replace(/[\s()]/g, ''));

	const vehicleTypeText = computed((): string => {
		let t = '';
		switch (props.vehicle?.StockCategoryId){
			case EStockCategoryId.new:
				t = 'New';
			break;
			case EStockCategoryId.used:
				t = (window as any).uvUsedCategoryLabel || '';
			break;
			case EStockCategoryId.demo:
				t = 'Demo';
			break;
		}
		return t;
	});

	const handlePhoneClick = (): void => {
		return;
	};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", null, [
        _createTextVNode(_toDisplayString(__props.vehicle?.ManuYear ? __props.vehicle.ManuYear : '') + " " + _toDisplayString(__props.vehicle?.Make) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(__props.vehicle?.Model), 1)
      ]),
      _createElementVNode("div", {
        class: "uv-details-buttons",
        onClick: handlePhoneClick
      }, [
        (__props.vehicle?.PhoneNumber)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _unref(vehicleHrefPhoneNumber)
            }, "Call Us", 8, _hoisted_2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (__props.vehicle?.IsToyotaCertifiedBool)
            ? (_openBlock(), _createBlock(VehicleFlagCertified, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(VehicleFlexSlider, {
            photos: __props.vehicle?.Photos || [],
            "default-alt": (__props.vehicle?.Make || '') + (__props.vehicle?.Model || '')
          }, null, 8, ["photos", "default-alt"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (__props.vehicle?.Location && __props.vehicle?.PhoneNumber)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                  _createTextVNode(_toDisplayString(__props.vehicle?.Location) + ": ", 1),
                  _createElementVNode("a", { href: _unref(vehicleHrefPhoneNumber) }, _toDisplayString(__props.vehicle?.PhoneNumber), 9, _hoisted_9)
                ]))
              : _createCommentVNode("", true)
          ]),
          (__props.vehicle?.Price)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createTextVNode(_toDisplayString(_unref(commify)(__props.vehicle?.Price)), 1)
                ]),
                (__props.vehicle?.Weekly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("span", _hoisted_15, [
                        _hoisted_16,
                        _createTextVNode(_toDisplayString(__props.vehicle?.Weekly) + " ", 1),
                        _hoisted_17
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("dl", null, [
              (__props.showLocation)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_19,
                    _createElementVNode("dd", null, _toDisplayString(__props.vehicle?.Location), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (__props.vehicle?.Year)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_20,
                    _createElementVNode("dd", null, _toDisplayString(__props.vehicle?.Year), 1)
                  ], 64))
                : _createCommentVNode("", true),
              _hoisted_21,
              _createElementVNode("dd", null, _toDisplayString(_unref(vehicleTypeText)), 1),
              (__props.vehicle?.Kms)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _hoisted_22,
                    _createElementVNode("dd", null, _toDisplayString(_unref(commify)(__props.vehicle?.Kms)), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (__props.vehicle?.Colour)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _hoisted_23,
                    _createElementVNode("dd", null, _toDisplayString(__props.vehicle?.Colour), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (__props.vehicle?.Transmission)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _hoisted_24,
                    _createElementVNode("dd", null, _toDisplayString(__props.vehicle?.Transmission), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (__props.vehicle?.Engine)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _hoisted_25,
                    _createElementVNode("dd", null, _toDisplayString(__props.vehicle?.Engine), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (__props.vehicle?.Body)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    _hoisted_26,
                    _createElementVNode("dd", null, _toDisplayString(__props.vehicle?.Body), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (__props.vehicle?.Vin)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                    _hoisted_27,
                    _createElementVNode("dd", null, _toDisplayString(__props.vehicle?.Vin), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (__props.vehicle?.Rego)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                    _hoisted_28,
                    _createElementVNode("dd", null, _toDisplayString(__props.vehicle?.Rego), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (__props.vehicle?.StockNum)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                    _hoisted_29,
                    _createElementVNode("dd", null, _toDisplayString(__props.vehicle?.StockNum), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", _hoisted_30, [
              (__props.vehicle?.DetailsPageUrl)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "button-solid",
                    href: __props.vehicle?.DetailsPageUrl
                  }, "Read more", 8, _hoisted_31))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})